module.exports = __webpack_public_path__ + "img/chart-area-solid.703ad0df.svg";